var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
	general: {
		limit: bcSfFilterConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
		numberFilterTree: 2
	}
};
// Declare Templates
var bcSfFilterTemplate = {
	'soldOutClass': ' sold-out',
	'saleClass': ' on-sale',
	'soldOutLabelHtml': '<span class="soldout bc-sf-filter-label">' + bcSfFilterConfig.label.sold_out + '</span>',
	'saleLabelHtml': '<span class="sale bc-sf-filter-label">' + bcSfFilterConfig.label.sale + '</span>',
	'tagLabelHtml': '<span class="tag bc-sf-filter-label {{labelTag}}" >{{labelTag}}</span>',
	'vendorHtml': '<p class="bc-sf-filter-product-item-vendor">{{itemVendorLabel}}</p>',
	// Grid Template
	'productGridItemHtml': '<div data-boost-theme-quickview="{{itemId}}" class="product-block {{gridClass}} {{quickBuyClass}}">' +
								'<div class="product-block__image-container global-border-radius hover-images {{imagesClass}} relative">' +
									'<a class="product-block__image" href="{{itemUrl}}">' +
										'{{itemImages}}' +
									'</a>' +
									'{{itemQuickBuy}}' +
								'</div>' +
								'<div class="product-block__title"><a class="product-block__title-link" href="{{itemUrl}}">{{itemTitle}}</a></div>' +
								'<div class="product-price">{{itemPrice}}</div>' +
								'{{itemSwatch}}' +
								'<div class="theme-product-reviews-summary">' +
									'{{itemReviews}}' +
								'</div>' +
							'</div>',
	// For List View
	// Pagination Template
	'previousActiveHtml': '<span class="prev"><a href="{{itemUrl}}">« Previous</a></span>',
	'previousDisabledHtml': '',
	'nextActiveHtml': '<span class="next"><a href="{{itemUrl}}">Next »</a></span>',
	'nextDisabledHtml': '',
	'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
	'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
	'pageItemRemainHtml': '<span class="deco">{{itemTitle}}</span>',
	'paginateHtml': '<div class="pagination large-row">{{previous}}{{pageItems}}{{next}}</div>',
	// Sorting Template
	'sortingHtml': '<div class="styled-dropdown styled-dropdown--label-inside">' + '<label for="bc-sf-filter-top-sorting-select" class="dropdown-label">' + bcSfFilterConfig.label.sorting + '</label><select id="bc-sf-filter-top-sorting-select">{{sortingItems}}</select>' + '</div>',
	// Show Limit Template
	'showLimitHtml': '<label>' + bcSfFilterConfig.label.show_limit + '</label><select class="bc-sf-filter-filter-dropdown">{{showLimitItems}}</select>',
	// Breadcrumb Template
	'breadcrumbHtml': '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> {{breadcrumbDivider}} {{breadcrumbItems}}',
	'breadcrumbDivider': '<span class="divider">/</span>',
	'breadcrumbItemLink': '<a href="{{itemLink}}">{{itemTitle}}</a>',
	'breadcrumbItemSelected': '<span>{{itemTitle}}</span>',
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
	// Get Template
	var itemHtml = bcSfFilterTemplate.productGridItemHtml;
	var images = data.images_info;
	var soldOut = !data.available; // Check a product is out of stock
	var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
	var priceVaries = data.price_min != data.price_max; // Check a product has many prices

	// Add Custom class
	var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
	var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';

	itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
	itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

	//Add grid class
	var gridClass = 'grid__item one-quarter small-down--one-half';
	if (bcSfFilterConfig.custom.grid_class != '') {
		gridClass = bcSfFilterConfig.custom.grid_class;
	}
	itemHtml = itemHtml.replace(/{{gridClass}}/g, gridClass);

	//Add quickbuy class & imagesClass
	var quickBuyClass = '';
	var imagesClass = '';
	var aspect_ratio = '';
	var aspect_ratio1 = '';
	if (images.length > 1 && bcSfFilterConfig.custom.hover_image_enabled) {
		imagesClass += ' hover-images--two ';
		aspect_ratio = images[0]['width'] / images[0]['height'];
		aspect_ratio1 = images[1]['width'] / images[1]['height'];
		if (aspect_ratio == aspect_ratio1) {
			imagesClass += ' same-aspect-ratio ';
		}
	}

	if (bcSfFilterConfig.custom.quick_buy) {
		quickBuyClass = ' js-contains-quickbuy ';
	}
	itemHtml = itemHtml.replace(/{{imagesClass}}/g, imagesClass);
	itemHtml = itemHtml.replace(/{{quickBuyClass}}/g, quickBuyClass);

	// Add item images
	var itemImagesHtml = '';
	itemImagesHtml += '<div class="image-one">';
	if (images.length > 0) {
		aspect_ratio = images[0]['width'] / images[0]['height'];
		itemImagesHtml += '<div class="rimage-outer-wrapper" style="max-width:' + images[0]['width'] + 'px; max-height: ' + images[0]['height'] + 'px">' +
			'<div class="rimage-wrapper lazyload--placeholder" style="padding-top: ' + 1 / aspect_ratio * 100 + '%">' +
			'<img class="rimage__image lazyload fade-in" src="data:image/svg+xml,%3Csvg%20xmlns=\'http://www.w3.org/2000/svg\'/%3E" ' +
			'data-src="' + this.optimizeImage(images[0]['src'], '{width}x') + '" ' +
			'data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"' +
			'data-aspectratio="' + aspect_ratio + '" ' +
			'data-sizes="auto" alt="{{itemTitle}}"' +
			'>' +
			'<noscript>' +
			'<img src="' + this.optimizeImage(images[0]['src'], '1024x1024') + '" class="rimage__image">' +
			'</noscript>' +
			'</div>' +
			'</div>';

	} else {
		itemImagesHtml += '<img src="' + bcSfFilterConfig.general.no_image_url + '">';
	}
	itemImagesHtml += '</div>';
	if (bcSfFilterConfig.custom.hover_image_enabled && images.length > 1) {
		itemImagesHtml += '<div class="image-two">' +
			'<div class="rimage-background fade-in lazyload" ' +
			'data-bgset="' + bgset(images[1]) + '" data-sizes="auto" data-parent-fit="cover"' +
			'>' +
			'<noscript>' +
			'<img src="' + this.optimizeImage(images[1]['src'], '1024x1024') + '" alt="{{itemTitle}}" class="rimage-background__image">' +
			'</noscript>' +
			'</div>' +
			'</div>';
	}
	itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

	//Add itemPrice
	var itemPriceHtml = '';
	if (priceVaries) {
		itemPriceHtml += '<span class="product-price__from">' + bcSfFilterConfig.label.from_text + '</span>';
	}
	if (onSale) {
		itemPriceHtml += '<span class="product-price__reduced theme-money">' + this.formatMoney(data.price_min, this.moneyFormat) + '\n</span>';
	} else {
		itemPriceHtml += '<span class="theme-money">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
	}

	if (onSale) {
		itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
		itemPriceHtml += '<span class="product-price__compare theme-money">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</span>';
	}

	if (!soldOut) {
		if (onSale) {
			itemPriceHtml += '<span class="product-label product-label--on-sale global-border-radius">' + bcSfFilterConfig.label.on_sale + '</span>';
		}
	} else {
		itemPriceHtml += '<span class="product-label product-label--sold-out global-border-radius">' + bcSfFilterConfig.label.sold_out + '</span>';
	}
	itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

	//Add quickbuy button
	var itemQuickBuyHtml = '';
	if (bcSfFilterConfig.custom.quick_buy) {
		itemQuickBuyHtml += '<a class="product-block__quicklook-btn btn--quicklook btn btn--primary js-quickbuy-button" href="{{itemUrl}}">' + bcSfFilterConfig.label.quick_buy + '</a>';
	}
	itemHtml = itemHtml.replace(/{{itemQuickBuy}}/g, itemQuickBuyHtml);

	var itemSwatchHtml = buildSwatch(data);
	itemHtml = itemHtml.replace(/{{itemSwatch}}/g, itemSwatchHtml);

	var itemReviewsHtml = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
	itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

	// Add main attribute (Always put at the end of this function)
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
	itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
	itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
	return itemHtml;
};

function buildSwatch(data) {
	var itemSwatchHtml = '';
	var values = [];
	if (bcSfFilterConfig.custom.swatch_enabled) {
		data.options_with_values.forEach(function (option, index) {
			var option_name = option.name.toLowerCase();
			if (bcSfFilterConfig.custom.swatch_option_name && option_name.indexOf(bcSfFilterConfig.custom.swatch_option_name.toLowerCase() != -1)) {
				itemSwatchHtml += '<div class="product-swatch-inline" data-swatch-count="3">';
				var i = 0;
				data.variants.forEach(function (variant) {
					var temp = variant.merged_options.filter(function (obj) {
						obj = obj.toLowerCase();
						if (obj.indexOf(bcSfFilterConfig.custom.swatch_option_name.toLowerCase()) != -1)
							return obj;
					});
					if (!temp || temp.length == 0) return;
					temp = temp[0].split(':');
					var value = temp[1].toLowerCase();
					if (values.indexOf(value) == -1) {
						values.push(value);
						var name_color = bcsffilter.slugify(value) + '.png';
						var url_color = bcSfFilterMainConfig.general.asset_url.replace('bc-sf-filter.js', name_color);
						itemSwatchHtml += '<span style="background-color: ' + value.replace(' ', '').toLowerCase() + '; background-image: url(' + url_color + ')" title="' + value + '" class="product-swatch-inline__dot bg-' + value + '">';
						itemSwatchHtml += '</span>';
						i++;
					}
				});
				itemSwatchHtml += '</div>';
			}
		});
	}
	return itemSwatchHtml;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
	// Get page info
	var currentPage = parseInt(this.queryParams.page);
	var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
	// If it has only one page, clear Pagination
	if (totalPage == 1) {
		jQ(this.selector.pagination).html('');
		return false;
	}
	if (this.getSettingValue('general.paginationType') == 'default') {
		var paginationHtml = bcSfFilterTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		jQ(this.selector.pagination).html(paginationHtml);
	}
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
	if (bcSfFilterConfig.custom.show_sort_by && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('');
		var sortingArr = this.getSortingList();
		if (sortingArr) {
			// Build content
			var sortingItemsHtml = '';
			for (var k in sortingArr) {
				sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
			}
			var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			jQ(this.selector.topSorting).html(html);
			// Set current value
			jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
		}
	}
};

// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function () {
	var itemHtml = '<span>' + bcSfFilterConfig.label.toolbar_viewas + '</span>';
	itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
	itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
	var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
	var listProductSelector = jQ(this.getSelector('products'));
	topDisplayTypeSelector.html(itemHtml);
	// Active current display type
	topDisplayTypeSelector.find('.bc-sf-filter-display-item').removeClass('active');
	if (this.queryParams.display == 'list') {
		topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
		listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
	} else if (this.queryParams.display == 'grid') {
		topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
		listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
	}
};

// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function () {
	if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
		jQ(this.selector.topShowLimit).html('');
		var numberList = this.getSettingValue('general.showLimitList');
		if (numberList != '') {
			// Build content
			var showLimitItemsHtml = '';
			var arr = numberList.split(',');
			for (var k = 0; k < arr.length; k++) {
				showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
			}
			var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
			jQ(this.selector.topShowLimit).html(html);
			// Set value
			jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
		}
	}
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function (colData, apiData) {
	if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
		var breadcrumbItemsHtml = '';
		if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
			var colInfo = colData.collection;
			if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
				breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
				breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
				breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
			} else {
				breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
			}
		} else {
			breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue('label.defaultCollectionHeader'));
		}
		var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml)
		html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
		jQ(this.selector.breadcrumb).html(html);
	}
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
	var self = this;
  	// Build content for Quick view
    this.buildExtrasProductListByAjax(data, 'boost-integration', function(results){
        results.forEach(function(result){
            // Append the custom html to product item
            jQ('[data-boost-theme-quickview="'+ result.id+ '"]').find('.btn--quicklook').append(result.quickshop_html);
        })
    });
	if (window.SPR){
		SPR.initDomEls();
		SPR.loadBadges();
	}
};
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) { };

function bgset(image) {
	var bgset = '';
	if (image) {
		var aspect_ratio = image.width / image.height;

		if (image.width > 180) bgset += ' ' + bcsffilter.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180 / aspect_ratio) + 'h,';
		if (image.width > 360) bgset += ' ' + bcsffilter.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360 / aspect_ratio) + 'h,';
		if (image.width > 540) bgset += ' ' + bcsffilter.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540 / aspect_ratio) + 'h,';
		if (image.width > 720) bgset += ' ' + bcsffilter.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720 / aspect_ratio) + 'h,';
		if (image.width > 900) bgset += ' ' + bcsffilter.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900 / aspect_ratio) + 'h,';
		if (image.width > 1080) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080 / aspect_ratio) + 'h,';
		if (image.width > 1296) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296 / aspect_ratio) + 'h,';
		if (image.width > 1512) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512 / aspect_ratio) + 'h,';
		if (image.width > 1728) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728 / aspect_ratio) + 'h,';
		if (image.width > 1950) bgset += ' ' + bcsffilter.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950 / aspect_ratio) + 'h,';
		if (image.width > 2100) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100 / aspect_ratio) + 'h,';
		if (image.width > 2260) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260 / aspect_ratio) + 'h,';
		if (image.width > 2450) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450 / aspect_ratio) + 'h,';
		if (image.width > 2700) bgset += ' ' + bcsffilter.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700 / aspect_ratio) + 'h,';
		if (image.width > 3000) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000 / aspect_ratio) + 'h,';
		if (image.width > 3350) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350 / aspect_ratio) + 'h,';
		if (image.width > 3750) bgset += ' ' + bcsffilter.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750 / aspect_ratio) + 'h,';
		if (image.width > 4100) bgset += ' ' + bcsffilter.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100 / aspect_ratio) + 'h,';
		bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
	}
	return bgset;
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
